import React from "react";
import { Drawer, Button, Tag, Divider } from "antd";

export const AdminDetailsModal = ({
  visible,
  title,
  status,
  statusColor,
  sections = [],
  onCancel,
  footerActions = [],
}) => {
  return (
    <Drawer
      title={title}
      open={visible}
      onClose={onCancel}
      placement="bottom"
      height="90vh"
      destroyOnClose
      className="rounded-t-3xl"
      styles={{
        body: {
          padding: "16px",
          overflow: "hidden",
        },
      }}
      bodyStyle={{
        padding: "16px",
        overflow: "hidden",
      }}
      footer={
        <div className="flex flex-wrap items-center justify-end gap-2 p-3">
          <Button key="close" onClick={onCancel} className="font-gilroyBold text-[13px] rounded-xl">
            Close
          </Button>
          {footerActions}
        </div>
      }
    >
      <div
        style={{
          maxHeight: "calc(90vh - 140px)",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}
        className="space-y-6 pb-6 pr-1"
      >
        {status && (
          <div className="p-4 bg-gray-50 rounded-xl flex justify-between items-center border border-gray-100">
            <span className="text-gray-600 font-bold text-[13px]">Status:</span>
            <Tag color={statusColor || (status === "APPROVED" || status === "active" ? "green" : status === "PENDING" ? "orange" : "red")} className="font-gilroyBold uppercase text-[12px] px-2.5 py-0.5 rounded-md border-0 m-0">
              {status.toUpperCase()}
            </Tag>
          </div>
        )}

        {sections.map((section, sIdx) => (
          <React.Fragment key={sIdx}>
            {sIdx > 0 && <Divider style={{ margin: "12px 0" }} />}
            <div
              className={`p-4 rounded-2xl border ${section.bgClass || "bg-blue-50 border-blue-200"
                }`}
            >
              {section.title && (
                <h3
                  className={`text-[14px] font-gilroyBold mb-3 ${section.titleColorClass || "text-blue-900"
                    }`}
                >
                  {section.title}
                </h3>
              )}
              <div className="space-y-2">
                {section.items.map((item, iIdx) => (
                  <div key={iIdx} className="flex justify-between items-center gap-4">
                    <span
                      className={`text-[13px] font-medium whitespace-nowrap ${section.labelColorClass || "text-blue-700"
                        }`}
                    >
                      {item.label}:
                    </span>
                    <span className="text-right text-gray-900 font-semibold text-[13px]">
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </Drawer>
  );
};

export default AdminDetailsModal;
